import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AccountState {
  selectedAccountId: string; // '' = all accounts
  setSelectedAccountId: (id: string) => void;
}

export const useAccountStore = create<AccountState>()(
  persist(
    (set) => ({
      selectedAccountId: '', // Default: all accounts
      setSelectedAccountId: (id) => set({ selectedAccountId: id }),
    }),
    {
      name: 'account-selection-storage',
    }
  )
);
